/**
 * Theme Store
 *
 * Manages dark/light mode theme using Zustand.
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useThemeStore = create(
  persist(
    (set, get) => ({
      theme: 'light',

      // Initialize theme from localStorage or system preference
      initTheme: () => {
        const { theme } = get();

        // Check if theme is already set in storage
        if (theme) {
          return;
        }

        // Check system preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          set({ theme: 'dark' });
        }
      },

      // Toggle between light and dark
      toggleTheme: () => {
        set((state) => ({
          theme: state.theme === 'light' ? 'dark' : 'light',
        }));
      },

      // Set specific theme
      setTheme: (theme) => {
        if (theme === 'light' || theme === 'dark') {
          set({ theme });
        }
      },

      // Check if dark mode
      isDark: () => get().theme === 'dark',
    }),
    {
      name: 'theme-storage',
    }
  )
);

export { useThemeStore };
